export default __webpack_public_path__ + "static/media/uefa24-prediction.6e10bc84.webp";